/**
 * Wording for the providers that would invent content.
 *
 * Which providers those are is decided by the server and reported by `/ready`:
 * a voice client built from a key with no narrator chosen is named
 * "elevenlabs" and still cannot speak, so the names alone cannot answer it.
 * This module only turns the answer into a sentence.
 */

/**
 * The providers whose absence is fiction rather than a simpler implementation.
 * `vision` is absent: its fallback still looks at the actual recording.
 */
export type ContentProvider = "transcription" | "script" | "voice";

const NAMES: Record<ContentProvider, string> = {
  transcription: "transcription",
  script: "the script model",
  voice: "narration",
};

/**
 * The gaps as a sentence.
 *
 * Named rather than counted: "two providers are unconfigured" sends someone to
 * Settings to work out which, and the answer is different for each.
 */
export function gapSentence(gaps: ContentProvider[]): string {
  if (gaps.length === 0) return "";

  const names = gaps.map((gap) => NAMES[gap]);
  const list = names.length === 1 ? names[0] : `${names.slice(0, -1).join(", ")} and ${names[names.length - 1]}`;
  const sentence = `${list} ${names.length === 1 ? "is" : "are"} not configured.`;

  return sentence.charAt(0).toUpperCase() + sentence.slice(1);
}
